export * from './assets';
export * from './auth';
export * from './devices';
export * from './playlists';
export * from "./playlistsV2";
export * from './tickers';
export * from './profile';
export * from './ui';
export * from './notifications';
export * from './channels';
export * from './tags';
export * from './user_reports';

export const getFetchingStatus = (state) => {
  let key;
  let fetchCount = 0;

  for (key in state) {
    
    if (state[key].isFetching === true) {
      fetchCount++;
    }
  }
   console.log("fetchCount",fetchCount)
  if (fetchCount > 5){
    return true;
  }

  return false;
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/selectors/index.js